<template>
  <div class="flex items-center gap-2 text-label">
    <template v-if="item.user?.full_name">
      <span class="shrink-0 whitespace-nowrap">{{ $t("COMMON.FROM") }}:</span>
      <span v-tooltipable class="max-w-50 shrink-0 truncate">
        {{ item.user.full_name }}
      </span>
    </template>
    <date-time :date="item.created_at" class="shrink-0 whitespace-nowrap" />
  </div>
</template>
<script setup lang="ts">
import DateTime from "@/components/ui/ConvertibleDateTime.vue";

import type { TaskLogData } from "@/models/communicationLogs";

const { item } = defineProps<{
  item: TaskLogData;
}>();
</script>
